export default "__VITE_ASSET__eEag1gLs__"